import { createContext, useContext } from "react";
import { SidebarProvider, SidebarInset } from "@/components/ui/sidebar";
import StandardSidebar from "@/components/StandardSidebar";
import { MobileHeader } from "@/components/MobileHeader";

const SidebarLayoutContext = createContext(false);

export function useSidebarLayoutContext() {
  return useContext(SidebarLayoutContext);
}

interface CandidateLayoutProps {
  children: React.ReactNode;
  activeRoute?: string;
}

export function CandidateLayout({ children, activeRoute }: CandidateLayoutProps) {
  const isInsideLayout = useSidebarLayoutContext();
  
  if (isInsideLayout) {
    return <>{children}</>;
  }
  
  return (
    <SidebarLayoutContext.Provider value={true}>
      <SidebarProvider defaultOpen={true}>
        <StandardSidebar activeRoute={activeRoute} />
        <SidebarInset className="bg-background min-h-screen overflow-x-hidden">
          <MobileHeader />
          {children}
        </SidebarInset>
      </SidebarProvider>
    </SidebarLayoutContext.Provider>
  );
}
